let language = {
    "4000": "不允许上传此文件",
    "4001": "文件内容非法",
    "4101": "文件内容非法",
};

export { language }